var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    { attrs: { visible: "", width: "55%" }, on: { close: _vm.onCancel } },
    [
      _c(
        "div",
        {
          staticClass: "authorise-dlg-title flex item-center",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("img", { attrs: { src: require("@/assets/img/icon-info.png") } }),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("authorise.p1"))),
          ]),
        ]
      ),
      _c("div", { staticClass: "flex border-normal p-15" }, [
        _c("img", {
          staticClass: "authorise-icon",
          attrs: { src: require("@/assets/img/icon-authorise.png") },
        }),
        _c(
          "div",
          { staticClass: "flex-1" },
          [
            _c("p", { staticClass: "authorise-title" }, [
              _vm._v(_vm._s(_vm.$t("authorise.title"))),
            ]),
            _c(
              "el-steps",
              {
                staticClass: "my-20 authorise-steps",
                attrs: {
                  direction: "vertical",
                  active: _vm.activeStep,
                  "finish-status": "success",
                },
              },
              [
                _c("el-step", {
                  attrs: { title: "", description: _vm.$t("authorise.step1") },
                }),
                _c("el-step", {
                  attrs: { title: "", description: _vm.$t("authorise.step2") },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            {
              staticClass: "btn-ok",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("authorise.ok")))]),
              _c("p", { staticClass: "mt-10 tips" }, [
                _vm._v(_vm._s(_vm.$t("authorise.okTips"))),
              ]),
            ]
          ),
          _c("div", { staticClass: "btn-no", on: { click: _vm.onNoConfirm } }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("authorise.no")))]),
            _c("p", { staticClass: "mt-10 tips" }, [
              _vm._v(_vm._s(_vm.$t("authorise.noTips"))),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }